import { subDays } from 'date-fns';
import * as yup from 'yup';

import {
  BillingCyclesUnit,
  BillingPeriodUnit,
  Plan} from '../../common/contracts';

export const getPlanSchema = () => {
  return yup.object().shape({
    name: yup.string().required('Plan Name is required'),
    displayName: yup.string().required('Display Name is required'),
    billingPeriodUnit: yup.string().required('Billing Period Unit is required'),
    description: yup
      .string()
      .notRequired()
      .max(300, 'Description must not exceed 300 characters'),
    price: yup
      .number()
      .min(0.8, 'Enter a price of $0.80 or higher')
      .required('Price is required'),
    isFirstPaymentDiscountEnabled: yup.boolean().notRequired(),
    firstPaymentDiscount: yup.number().when('isFirstPaymentDiscountEnabled', {
      is: true,
      then: yup.number().min(1, 'Enter a discount of 1% or higher').required(),
      otherwise: yup.number().notRequired()
    }),
    billingCyclesUnit: yup.string().required('Billing Cycle is required'),
    billingCycles: yup.number().when('billingCyclesUnit', {
      is: (val: string) => val === BillingCyclesUnit.FIXED_NUMBER_OF_PAYMENTS,
      then: yup
        .number()
        .required('Billing Cycles is required')
        .min(1, 'Number of cycles must be at least 1'),
      otherwise: yup.number().notRequired()
    })
  });
};

export const getCreatePlanFromInitialValues = (
  plan?: Plan
): CreatePlanFormValues => {
  return {
    name: plan?.name || '',
    displayName: plan?.displayName || '',
    description: plan?.description || '',
    billingPeriodUnit: plan?.billingPeriodUnit || BillingPeriodUnit.DAILY,
    price: (plan?.basePriceInUsd || 0) / 100,
    isFirstPaymentDiscountEnabled: Boolean(plan?.coupon?.discountPercentage),
    billingCyclesUnit:
      plan?.billingCyclesUnit || BillingCyclesUnit.FIXED_NUMBER_OF_PAYMENTS,
    billingCycles: plan?.billingCycles || 0,
    firstPaymentDiscount: plan?.coupon?.discountPercentage || 0
  };
};

export const DEFAULT_DATE_RANGE = {
  from: subDays(new Date(), 30),
  to: new Date()
};

export interface CreatePlanFormValues {
  name: string;
  displayName: string;
  description: string;
  billingPeriodUnit: BillingPeriodUnit;
  price: number;
  isFirstPaymentDiscountEnabled: boolean;
  firstPaymentDiscount: number;
  billingCyclesUnit: BillingCyclesUnit;
  billingCycles?: number;
}
